<template>
<div>
<TheHeader/>
 <div class="c-app flex-row align-items-center bg-overlay" v-if="user">  
     <CContainer>
        <div v-if="!success&&user&&user.subscriptionType.id!='subscription_free'">
            <CRow class="justify-content-center">
                <CCol md="7">
                  <CCardGroup >
                    <CCard class="p-5" style="background-color:#2E2E2E;border-color:#2E2E2E; border-radius: 20px;">
                      <CCardBody  >
                        <h1 style="text-align:center; color:white; font-size:28px; padding-bottom:20px;">{{user.firstName}} !</h1>
                        <h1 style="text-align:center; color:white; font-size:28px; padding-bottom:20px; font-weight: bold;">
                          You already redeem your gift card
                        </h1>
                      </CCardBody>
                    </CCard>
                  </CCardGroup>
                </CCol>
            </CRow>
            <CRow class="justify-content-center">
                <CCol md="5">
                  <CCardGroup >
                    <CCard style="background-color:rgba(0,0,0,.85);border-bottom-left-radius: 15px; border-bottom-right-radius: 20px;">
                      <CCardBody >
                        <p class ="p-2" style="width:100%; color:#C1C1C1; text-align:center">Proceed to download the app in the App Store or Google Play Store</p>
                        <div class="row">
                            <div class="col-6">
                              <a href="https://apps.apple.com/in/app/aumhum/id1474055225">
                                      <img class="form-group rounded mx-auto d-block" src="/img/appstore.png" width="150"></a>
                            </div>
                            <div class="col-6">
                                <a href="https://play.google.com/store/apps/details?id=com.aumhum.aumhum">
                                <img class="form-group mx-auto d-block" src="/img/playstore.png" width="150"> </a>
                            </div>
                        </div>
                      </CCardBody>
                    </CCard>
                  </CCardGroup>
                </CCol>
            </CRow> 
      </div>
      <div v-if="!success&&user&&user.subscriptionType.id=='subscription_free'">
          <CRow class="justify-content-center">
              <CCol md="7">
                <CCardGroup >
                  <CCard class="p-5" style="background-color:#2E2E2E;border-color:#2E2E2E; border-radius: 20px;">
                    <CCardBody  >
                      <h1 style="text-align:center; color:white; font-size:28px; padding-bottom:20px;">{{user.firstName}} !</h1>
                      <h1 style="text-align:center; color:white; font-size:28px; padding-bottom:10px; font-weight: bold;">
                        Redeem your gift card
                      </h1>
                      <p class="pb-2" style="width:100%; color:#C1C1C1; text-align:center">Enjoy your innerself in your meditation journey</p>
                        <div class="row" style="border: solid; border-color: gray; border-width: 1px; border-radius: 30px;">
                          <div class="col-8">
                            <div class="form-group" style="margin-bottom: 0px;">
                              <input
                              placeholder="Entry your code"
                              v-model="couponCode"
                              type="password"
                              class="form-control material-input "
                              style="border-bottom:0px; "
                              />
                            </div>
                          </div>
                          <div class="col-4 redeem-btn-div">
                              <p v-if="couponCode==''" style="width:100%; color:#C1C1C1; text-align:center;" class="redeem-btn-txt">
                                <span v-if="$isMobile()">Redeem</span>
                                <span v-else>Redeem Now</span>
                              </p>
                              <button v-else type="button" style="width:100%;border-radius:30px;" class="btn btn-aumhum redeem-btn" @click="redeemCouponCode()">
                                <span v-if="$isMobile()">Redeem</span>
                                <span v-else>Redeem Now</span>
                              </button>
                          </div>
                        </div>
                        <small style="padding-left:10px; color: #F3756B!important;" v-if="msg.title">{{msg.title}}&nbsp;{{msg.desc}}</small>
                         <!-- <CRow v-if="msg.enabled" class="pt-2">
                          <CCol col="12" >
                            <b-alert  show dismissible @dismissed="msg.enabled=false" :variant="msg.variant">
                              <h5 class="alert-heading">{{msg.title}}</h5>
                              <p>
                                  {{msg.desc}}
                              </p>
                            </b-alert>
                          </CCol>
                        </CRow> -->
                    </CCardBody>
                  </CCard>
                </CCardGroup>
              </CCol>
          </CRow>
          <CRow class="justify-content-center">
              <CCol md="5">
                <CCardGroup >
                  <CCard style="background-color:rgba(0,0,0,.85);border-bottom-left-radius: 15px; border-bottom-right-radius: 20px; border-top-left-radius: 0px; border-top-right-radius: 0px;" >
                    <CCardBody >
                      <p class ="p-2" style="width:100%; color:#C1C1C1; text-align:center">Proceed to download the app in the <span style="color:white"> App Store </span> or <span style="color:white">Google Play</span> Store
                      <div class="row">
                          <div class="col-6">
                            <a href="https://apps.apple.com/in/app/aumhum/id1474055225">
                                    <img class="form-group rounded mx-auto d-block" src="/img/appstore.png" width="150"></a>
                          </div>
                          <div class="col-6">
                              <a href="https://play.google.com/store/apps/details?id=com.aumhum.aumhum">
                              <img class="form-group mx-auto d-block" src="/img/playstore.png" width="150"> </a>
                          </div>
                      </div>
                    </CCardBody>
                  </CCard>
                </CCardGroup>
              </CCol>
          </CRow>
      </div> 
      <div v-if="success">
        <CRow class="justify-content-center">
              <CCol md="7">
                <CCardGroup >
                  <CCard style="background-color:rgba(0,0,0,.85); border-radius: 20px;" >
                    <CCardBody >
                        <img class="form-group mx-auto d-block" src="/img/Cong-ill.png" width="200">
                        <h1 style="text-align:center; color:#008890; font-size:28px;">Congratulations</h1>
                        
                         <div class="row">
                              <div class="col-4 offset-4">
                                  <hr style="background-color: #707070; border: 2px solid #707070; border-radius: 2px;"/>
                              </div>
                         </div>
                        <p  style="width:100%; color:#C1C1C1; text-align:center">You are now a 
                          <span style="color:white">Premium member</span>
                        </p>
                        <p class ="pb-2" style="width:100%; color:#C1C1C1; text-align:center">Proceed to download the app in the <span style="color:white"> App Store </span> or <span style="color:white">Google Play</span> Store</p>
                      <div class="row">
                          <div class="col-6">
                            <a href="https://apps.apple.com/in/app/aumhum/id1474055225">
                                    <img class="form-group rounded mx-auto d-block" src="/img/appstore.png" width="150"></a>
                          </div>
                          <div class="col-6">
                              <a href="https://play.google.com/store/apps/details?id=com.aumhum.aumhum">
                              <img class="form-group mx-auto d-block" src="/img/playstore.png" width="150"> </a>
                          </div>
                      </div>
                    </CCardBody>
                  </CCard>
                </CCardGroup>
              </CCol>
          </CRow>
      </div>
     </CContainer> 

 </div>
<TheFooter/>
     <Loading :active.sync="isLoading" 
        color="#F3756B"
        background-color="#000"
        :opacity="0.9"
        loader="spinner"
        :is-full-page="true">
    </Loading>
</div>
</template>
<script>
//import config from '@/config'
import User from '@/modules/user/user.js';
import '@/assets/app.css'
import TheHeader from '@/components/layout/TheDarkHeader'
import TheFooter from '@/components/layout/TheDarkFooter'
import Loading from 'vue-loading-overlay';

export default {
  name: 'Profile',
  components: {
   // TheSidebar,
    TheHeader,
    TheFooter,
    Loading
  },
  data() {
    return {
      couponCode:'',
      redeemCoupon:false,
      error:false,
      success:false,
      errorMsg:'',
      isLoading:false,
      msg:{
        enabled:false,
      }

    }
  },
  computed : {
    user() {
      return this.$store.state.auth.loginData;
    },
    facebookProvider(){
       return this.getSocialProviderId('facebook');
    },
    googleProvider(){
       return this.getSocialProviderId('google');
    },
    appleProvider(){
      return this.getSocialProviderId('apple');
    }
  },
  methods : {

    getSocialProviderId(provider){
      var result = '--';
      if(this.user&&this.user.socialConnections){
        var socialConnection = this.user.socialConnections;
        if(socialConnection){
          socialConnection.forEach(element => {
            if(element.providerId==provider){
              result = element.providerUserId;
            }
          });
        }
      }
      return result;
    },
    redeemCouponCode(){
      var self = this;
      self.isLoading = true;
      User.redeemCoupon(self.couponCode)
      .then(() => {
          self.isLoading=false;
          self.redeemCoupon = false;
          self.success = true;
          this.$store.dispatch('auth/refreshLoginData');
      })
      .catch((e)=> {
        self.isLoading=false;
        self.msg.enabled = true;
        self.msg.variant = 'light'
        self.msg.title = 'Failed!';
        if( e.response ){
            console.log(e.response.data); // => the response payload 
            self.msg.desc = e.response.data.message;
        }else{
          console.log(e);
          self.msg.desc = 'NETWORK ISSUE.';
        }
      })
    }
  }
}
</script>

<style scoped>
  .redeem-btn-txt {
    margin-top:12px;
  }

  .redeem-btn {
    margin-top:6px;
  }

  @media(max-width: 768px) {
    .redeem-btn-div {
      padding: 5px;
    }

    .redeem-btn-txt {
      margin-top:12px;
      font-size: .8rem;
      line-height: 1.5;
    }

    .redeem-btn {
      margin-top:4px;
      font-size: .8rem;
      line-height: 1.5;
    }
  }
</style>